import { ActionTypes } from '@/types';

// Export enum values as constants for backward compatibility
export const USER_LOGOUT = ActionTypes.USER_LOGOUT;
export const USER_FETCH = ActionTypes.USER_FETCH;
export const SET_AUTH_USER = ActionTypes.SET_AUTH_USER;
export const SET_PAGE_TITLE = ActionTypes.SET_PAGE_TITLE;
